<template>
    <div>
        <main role="main"  style = "padding-top:75px">
            <div class="container-fluid">
                <SalesListHeader @getList = "getList"></SalesListHeader>
				<!-- <SalesActions/> -->
				<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;margin-top:60px"></div>
				<div v-else>
					<SalesListGrid></SalesListGrid >
					<SalesListFooter @getList = "getList"></SalesListFooter>
				</div>
            </div>
        </main>
    </div>
</template>

<script>
import SalesListHeader from '@/components/sales-diagnostic/SalesListHeader'
import SalesListGrid from '@/components/sales-diagnostic/SalesListGrid'
import SalesListFooter from '@/components/sales-diagnostic/SalesListFooter'
import SalesActions from '@/components/sales-diagnostic/SalesActions'


export default {

    name: 'SalesList',
    data() {
        return {
			showLoader:false
        }
    },
    components: {
        SalesListHeader,
        SalesListGrid,
        SalesListFooter,
		SalesActions
    },
    mounted() {
		this.getList()
    },
	methods:{
		getList(){
			let vm = this;
			this.showLoader = true
			this.$store.dispatch("sales/getList").then((res) => {
				vm.showLoader = false
			})
		}
	}
}
</script>

<style lang="scss">

</style>
